import { useCallback, useState } from 'react';

import { useConceptGroupMaps } from '../../hooks/useConceptGroupMaps';
import type { ConceptGroupOption } from '../../types';

export const useConceptGroupChip = (conceptGroups: ConceptGroupOption[]) => {
  const [selectedChipConceptGroupId, setSelectedChipConceptGroupId] = useState<string>();

  const { nameToIdMap: conceptGroupNameToIdMap } = useConceptGroupMaps(conceptGroups);

  const handleChipClick = useCallback(
    (name: string) => {
      const id = conceptGroupNameToIdMap.get(name.toLowerCase());
      if (id) setSelectedChipConceptGroupId(id);
    },
    [conceptGroupNameToIdMap]
  );

  const handleCloseConceptGroupDetails = useCallback(() => {
    setSelectedChipConceptGroupId(undefined);
  }, []);

  return {
    selectedChipConceptGroupId,
    handleChipClick,
    handleCloseConceptGroupDetails,
  };
};
